import { render, staticRenderFns } from "./AllActivities.vue?vue&type=template&id=51208418&scoped=true"
import script from "./AllActivities.vue?vue&type=script&lang=js"
export * from "./AllActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51208418",
  null
  
)

export default component.exports